import privacyPolicyComponent from './privacyPolicy';
import termsAndConditionComponent from './termsAndCondition';

const privacyPolicy = privacyPolicyComponent;
const termsAndCondition = termsAndConditionComponent;

export { privacyPolicy, termsAndCondition };
